import { IconNames } from "../Icon/types";

export interface Category {
  title: string;
  category: string;
  route: string;
  link?: string;
  isExternalLink?: boolean;
  icon: IconNames;
}

export const CATEGORIES: Category[] = [
  {
    title: "Cart",
    category: "cart",
    route: "/store/cart",
    icon: "ShoppingCartWhite",
  },
  {
    title: "Quick Order",
    category: "quickorder",
    route: "/quick-order",
    icon: "Pencil",
  },
  {
    title: "Saved Orders",
    category: "savedorders",
    route: "/saved-orders",
    icon: "Save",
  },
  {
    title: "Order Import",
    category: "orderimport",
    route: "/order-uploader",
    icon: "FileUpload",
  },
  {
    title: "Order History",
    category: "orderhistory",
    route: "/order-history",
    icon: "BoxOpen",
  },
  {
    title: "Transactions",
    category: "transactions",
    route: "/transactions",
    icon: "CreditCard",
  },
  {
    title: "Preferences",
    category: "preferences",
    route: "/preferences",
    icon: "Cog",
  },
  {
    title: "Promotions",
    category: "promotions",
    route: "/store/cart?tab=promotions",
    icon: "StarWhite",
  },
  {
    title: "Consolidated Media Library",
    category: "medialibrary",
    route: "/media-library",
    link: "https://drive.google.com/drive/folders/1b0psR81rxlQPe_O8t4WkgyUHVx9Mq_i2?usp=drive_link",
    isExternalLink: true,
    icon: "PhotoVideo",
  },
  {
    title: "Digital Catalogues",
    category: "digital catalogue",
    route: "/digital-catalogue",
    icon: "StarWhite",
  },
];

export interface WebDataLinks {
  title: string;
  linkAU: string;
  linkNZ: string;
  icon: IconNames;
}

export const webData: WebDataLinks[] = [
  {
    title: "Web Data",
    icon: "PhotoVideo",
    linkAU: "https://drive.google.com/drive/folders/1JpiF1ou0_c98p9jiuKC2taPC5bz3caux?usp=drive_link",
    linkNZ: "https://drive.google.com/drive/folders/1GxxxRt9NfumwrIv8S70jA6_yqoCuNGgz?usp=drive_link",
  },
]
